<mat-card>
    <mat-card-header>
        <mat-card-title class="popupHeader">
            <div class="mat-card-header-text" i18n>
                Language
              </div>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="languageBox">
            <div class="languageSection">
                <div class="languageContent" (click)="changeLanguage('DE')">
                    <p class="languageType" i18n>GERMAN</p>
                    <mat-icon *ngIf="isGerman === true">check</mat-icon>
                </div>
            </div>
            <div class="sectionDivider"></div>
            <div class="languageSection">
                <div class="languageContent" (click)="changeLanguage('EN')">
                    <p class="languageType" i18n>ENGLISH</p>
                    <mat-icon *ngIf="isEnglish === true">check</mat-icon>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
